<ion-modal #modalMedia
    class="demooz_modal_media" 
    [canDismiss]="this.canDismissMediaModal.bind(this)"
    (didDismiss)="this.onDidDismissMediaModal($event)"       
    >
    <ng-template>        
        <ion-content>
            <div class="demooz_modal_media_content">
                <div class="btn_close_modal">
                    <ion-icon name="close-outline" (click)="this.dismiss()"></ion-icon>
                </div>

                @if(this.isFetchingMedia){
                    <div class="bloc_loading">
                        <ion-spinner></ion-spinner>
                    </div> 
                }

                @if(this.urlMedia){
                    @if(this.isVideo){
                        <video [src]="this.urlMedia" [class.hide_media]="this.isFetchingMedia" autoplay controls (loadeddata)="this.onLoadMedia()"></video>
                    }
                    @else{
                        <img [src]="this.urlMedia" [class.hide_media]="this.isFetchingMedia" (load)="this.onLoadMedia()"/>
                    }
                }
            </div>
        </ion-content>
    </ng-template>
</ion-modal>
            